export const environment = {
  production: true,
  mains: [
    { name: 'navigation', url: 'https://personal-navigation.phichitsakuldes.com' },
    { name: 'personal-chat', url: 'https://chat.phichitsakuldes.com' },
  ],
};
